export default function event(eventName, parameters = {}){
    gtag('event', eventName, parameters);
}